<template>
  <div class="table table-bg">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>부서 리스트</h2>
      </div>
      <div class="table-btn center-right">
        <div class="btn-frige-register" @click="createDivision">
          <button class="btn btn-140"><span><img src="/static/img/ico-plus-white@2x.png" alt=""></span>부서 등록</button>
        </div>
        <div class="btn-renew" @click="refreshList">
          <button class="btn btn-40"><span><img src="/static/img/ico-renew@2x.png" alt=""></span></button>
        </div>
        <!-- <div class="btn-export-excel" @click="downloadExcel">
          <button class="btn btn-40"><span><img src="/static/img/ico_excel@2x.png" alt=""></span></button>
        </div> -->
      </div>
    </div>
    <div class="table-desc">
      <table>
        <tr class="header">
          <th>부서 ID</th>
          <th>부서 이름</th>
          <th>회사 ID</th>
          <th>회사 이름</th>
          <th>사업자번호</th>
          <th>역할</th>
        </tr>

        <tbody v-if="loading === false && pagination.total > 0">
          <tr v-for="item in divisionList" :key="item.divisionID" @click="goDetail(item)">
            <td>
              <!-- TODO <div>{{ item.divisionAlias }}</div> -->
              <div>{{ item.divisionID }}</div>
            </td>
            <td>
              <div>{{ item.divisionName }}</div>
            </td>
            <td>
              <!-- TODO<div>{{ item.companyAlias }}</div> -->
              <div>{{ item.companyID }}</div>
            </td>
            <td>
              <div>{{ item.companyName }}</div>
            </td>
            <td>
              <div>{{ item.registrationNo }}</div>
            </td>
            <td>
              <div>{{ $getConstName('companyScope', item.scope) }}</div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="6">등록된 부서가 없습니다.</td>
          </tr>
        </tbody>
      </table>

      <div class="pagination" v-if="pagination.total > 0">
        <span class="pagination-prev" @click="goPrev">
          <img src="/static/img/ico-arrow-line.png" alt />
        </span>

        <span v-if="pagination.pageArray[0] > 1" @click="goPage(1)">1</span>
        <span v-if="pagination.pageArray[0] > 1" @click="jumpPrev">...</span>
        <span
          v-for="n in pagination.pageArray"
          :key="n"
          :class="n === pagination.page ? 'page-num current' : 'page-num'"
          @click="goPage(n)"
          >{{ n }}
        </span>
        <span
          v-if="
            pagination.pageArray[pagination.pageArray.length - 1] <
            pagination.length
          "
          @click="jumpNext"
          >...
        </span>
        <span
          v-if="
            pagination.pageArray[pagination.pageArray.length - 1] <
            pagination.length
          "
          @click="goPage(pagination.length)"
          >{{ pagination.length }}
        </span>

        <span class="pagination-next" @click="goNext">
          <img src="/static/img/ico-arrow-line.png" alt />
        </span>

        <input
          type="number"
          v-model="pagination.input"
          @keyup.enter="goPage(Number(pagination.input))"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-unused-vars */

import Configuration from '@/js/Configuration';

export default {
  props: [
    'searchCondition',
    'searchEvent',
    'startTime',
    'endTime',
    'companyID',
    'companyName',
    'companyAlias',
    'registrationNo',
    'scope',
  ],
  data: () => ({
    divisionList: [],
    sum: null,
    pagination: {
      page: 1,
      total: 0,
      length: 1,
      perPage: 10,
      perLength: 5,
      pageArray: [],
      input: 1,
    },
    loading: true,
  }),
  created() {
    this.loadPagination();
    this.getDivisionList();
  },
  watch: {
    searchEvent() {
      this.pagination.page = 1;
      this.pagination.input = 1;
      this.pagination.total = 0;
      this.pagination.length = 1;

      this.getDivisionList();
    },
  },
  methods: {
    refreshList() {
      this.getDivisionList();
    },
    savePagination() {
      const page = {
        division: this.pagination.page,
      };
      sessionStorage.setItem('pagination', JSON.stringify(page));
    },
    loadPagination() {
      const page = JSON.parse(sessionStorage.getItem('pagination'));
      if (page !== null && page.division !== undefined) this.pagination.page = page.division;
    },
    async getDivisionList() {
      this.savePagination();
      this.divisionList = [];
      this.pagination.input = this.pagination.page;
      this.loading = true;

      try {
        let countURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/division/count?companyID=${this.companyID}`;
        if (this.searchCondition) {
          countURL += `&${this.searchCondition}`;
        }
        const count = await this.$http.get(countURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (count.status !== 200) {
          throw new Error(`Response status is "${count.status}"`);
        }
        if (count.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${count.data.resultCode}"`);
        }
        if (count.data.count < 1) {
          this.pagination.page = 1;
          this.pagination.total = 0;
          this.pagination.length = 1;
          this.loading = false;
          return;
        }

        this.pagination.total = count.data.count;
        this.pagination.length = Math.ceil(
          this.pagination.total / this.pagination.perPage,
        );

        const pageBack = Math.floor((this.pagination.perLength - 1) / 2);
        const pageForward = this.pagination.perLength - 1 - pageBack;
        let firstPage = this.pagination.page - pageForward;
        let lastPage = this.pagination.page + pageBack;
        if (firstPage < 1) {
          firstPage = 1;
          lastPage = this.pagination.perLength;
        }
        if (lastPage > this.pagination.length) {
          lastPage = this.pagination.length;
        }
        if (lastPage - firstPage + 1 < this.pagination.perLength) {
          if (firstPage > 1) {
            firstPage -= this.pagination.perLength - lastPage + firstPage - 1;
            if (firstPage < 1) {
              firstPage = 1;
            }
          } else if (lastPage < this.pagination.length) {
            lastPage += this.pagination.perLength - lastPage + firstPage - 1;
            if (lastPage > this.pagination.length) {
              lastPage = this.pagination.length;
            }
          }
        }

        this.pagination.pageArray = [];
        for (let i = firstPage; i <= lastPage; i++) {
          this.pagination.pageArray.push(i);
        }

        let num =
          this.pagination.total -
          (this.pagination.page - 1) * this.pagination.perPage;
        const divisionList = [];

        let listURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/division/list?companyID=${this.companyID}&page=${this.pagination.page}&limit=${
          this.pagination.perPage
        }`;
        if (this.searchCondition) {
          listURL += `&${this.searchCondition}`;
        }
        const list = await this.$http.get(listURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (list.status !== 200) {
          if (list.status === 204) {
            this.pagination.page = 1;
            this.pagination.total = 0;
            this.pagination.length = 1;
            this.loading = false;
            return;
          }

          throw new Error(`response status is "${list.status}"`);
        }
        if (list.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${list.data.resultCode}"`);
        }

        for (let i = 0; i < list.data.divisions.length; i++) {
          const p = list.data.divisions[i];

          const division = {
            divisionID: p.divisionID,
            divisionName: p.divisionName,
            divisionAlias: p.divisionAlias,
            companyID: this.companyID,
            companyName: this.companyName,
            companyAlias: this.companyAlias,
            registrationNo: this.registrationNo,
            scope: this.scope,
          };
          divisionList.push(division);

          num--;
        }

        this.divisionList = divisionList;
        this.loading = false;
      } catch (e) {
        this.pagination.page = 1;
        this.pagination.total = 0;
        this.pagination.length = 1;
        this.divisionList = [];
        this.loading = false;
        console.error(e);
      }
    },
    goPrev() {
      if (this.pagination.page <= 1) {
        return;
      }
      this.pagination.page--;

      this.getDivisionList();
    },
    goNext() {
      if (this.pagination.page >= this.pagination.length) {
        return;
      }
      this.pagination.page++;

      this.getDivisionList();
    },
    jumpPrev() {
      if (
        Array.isArray(this.pagination.pageArray) &&
        this.pagination.pageArray.length > 0
      ) {
        this.pagination.page = this.pagination.pageArray[0];
        this.pagination.page--;
      } else {
        this.pagination.page = 1;
      }

      if (this.pagination.page < 1) {
        this.pagination.page = 1;
      }

      this.getDivisionList();
    },
    jumpNext() {
      if (
        Array.isArray(this.pagination.pageArray) &&
        this.pagination.pageArray.length > 0
      ) {
        this.pagination.page = this.pagination.pageArray[
          this.pagination.pageArray.length - 1
        ];
        this.pagination.page++;
      } else {
        this.pagination.page = 1;
      }

      if (this.pagination.page > this.pagination.length) {
        this.pagination.page = this.pagination.length;
      }

      this.getDivisionList();
    },
    goPage(page) {
      if (page < 1) {
        page = 1;
      }
      if (page > this.pagination.length) {
        page = this.pagination.length;
      }
      this.pagination.page = page;
      this.getDivisionList();
    },
    goDetail(division) {
      this.$emit('divisionDetail', division);
    },
    createDivision() {
      const company = {
        companyID: this.companyID,
        companyName: this.companyName,
        companyAlias: this.companyAlias,
        registrationNo: this.registrationNo,
        scope: this.scope,
      };
      this.$emit('divisionCreate', company);
    },
    downloadExcel() {},
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/account/division/DivisionList.vue